import { BaseAuthService, SessionExpiredError, delay } from '@agendor/ui';

export { SessionExpiredError };

export default class AuthService extends BaseAuthService {
    async refreshAccessToken(): Promise<boolean> {
        return this._refreshAccessToken();
    }

    protected async _refreshAccessToken(): Promise<boolean> {
        const refresh = () =>
            fetch(`${this.serverRootPath}/auth/refresh`, {
                method: 'POST',
                credentials: 'include',
            });

        let response = await refresh();

        // 409 means another app rotated the token; wait for cookie update and retry
        if (response.status === 409) {
            await delay(500);
            response = await refresh();
        }

        if (!response.ok) {
            this.clearAccessToken();
            return false;
        }

        const { accessToken } = await response.json();
        this.setAccessToken(accessToken);
        return true;
    }

    async logout(): Promise<void> {
        return this._logout();
    }

    protected async _logout(): Promise<void> {
        try {
            await fetch(`${this.serverRootPath}/auth/logout`, {
                method: 'POST',
                credentials: 'include',
            });
        } finally {
            this.clearAccessToken();
        }
    }
}
